module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-breadcrumb"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf1c726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblBreadcrumb/src/vblBreadcrumb.vue
// module id = 270
// module chunks = 0